/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Settings for LOW_RESOURCE_COMPATIBILITY.
 */
export interface AnalyticsCheckSettingsLowResourceCompatibilityLastmile { 
    /**
     * Percent.
     */
    percent?: number;
}

